import * as yup from "yup";
import { ObjectShape } from "yup/lib/object";

export interface Validation {
  validateSyncObject: any;
  schema: yup.ObjectSchema<ObjectShape>;
  updateErrors: (value: yup.ValidationError[]) => void;
}

const handleValidationSuccess = (validate: Validation, context?: any): boolean => {
  const { schema, validateSyncObject, updateErrors } = validate;

  schema.validateSync(validateSyncObject, { context, abortEarly: false });
  updateErrors([]);

  return true;
};

const handleValidationError = (error: yup.ValidationError, validate: Validation): boolean => {
  if (error?.inner) validate.updateErrors(error?.inner);

  return false;
};

export const handleValidation = (validate: Validation, context?: any): boolean => {
  try {
    return handleValidationSuccess(validate, context);
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      return handleValidationError(error, validate);
    }

    return false;
  }
};
